import { useCallback, useState } from 'react';

import { captureException } from '~/utils/exception-tracking';

/**
 * Sync state to localStorage with the same API as useState()
 *
 * Pulled from https://usehooks.com/useLocalStorage/
 */
export const useLocalStorage = (key, initialValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (err) {
      captureException(err);
      return initialValue;
    }
  });

  const setValue = useCallback(
    (value) => {
      try {
        const valueToStore =
          value instanceof Function ? value(storedValue) : value;

        setStoredValue(valueToStore);
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
      } catch (error) {
        captureException(error);
      }
    },
    [key, storedValue]
  );

  return [storedValue, setValue];
};
